<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: '#0E8FB9',
    }"
  >
    <div
      class="page-wrapper"
      :style="{
        backgroundImage: `url(https://assets.rurushishi.com/activies/football/bg.jpg)`,
      }"
    >
      <!-- <div class="kv"><img rc="https://assets.rurushishi.com/activies/football/ouzhoubei.png" /></div> -->
      <div class="myinfo">
        <div class="info-l">
          <img :src="myPointData.headImg" alt="" />
          <span>{{ myPointData.name }}</span>
        </div>
        <div class="info-r">
          <div class="agg-integral">
            <div class="num">{{ myPointData.totalPoint }}</div>
            <div class="tit">总澳朵金豆</div>
          </div>
          <div class="solid"></div>
          <div class="sur-integral">
            <div class="num">{{ myPointData.currentPoint }}</div>
            <div class="tit">剩余澳朵金豆</div>
          </div>
        </div>
      </div>
      <div class="model" :style="{ borderColor: '#58A72A' }">
        <!-- <div
            class="modelTitle"
            :style="{
              backgroundColor: '#58A72A',
              color: configInfo.buttonTextColour,
            }"
          >
            · 我的奖品 ·
          </div> -->

        <div class="modelBg">
          <div class="head-tab">
            <div
              :class="{ 'act-tab': selsectType == 'guess' }"
              @click="changeTag('bility')"
            >
              我的竞猜
            </div>
            <div
              :class="{ 'act-tab': selsectType == 'bility' }"
              @click="changeTag('guess')"
            >
              奖品兑换
            </div>
          </div>
          <div class="guess" v-if="ShowList">
            <div v-for="(item, index) in myGuessData" :key="index">
              <div class="time-data">
                {{ item.contestTime.slice(5, 7) }}月{{
                  item.contestTime.slice(8, 10)
                }}日
              </div>
              <div class="game schedule">
                <div class="game-item">
                  <div class="item-l">
                    <div class="nation">
                      <div class="nation-l">
                        <img :src="item.homeTeamFlag" alt="" />
                        <span>{{ item.homeTeamName }}</span>
                      </div>
                      <div class="nation-l">
                        <img :src="item.awayTeamFlag" alt="" />
                        <span>{{ item.awayTeamName }}</span>
                      </div>
                    </div>
                    <div class="score">
                      <div class="victory">
                        <div class="xqd">
                          <div class="bifen" v-if="item.homeScore > -1">
                            {{ item.homeScore }}
                          </div>
                          <div class="bifen" v-else>--</div>
                          <div
                            class="yz-jg"
                            :style="{
                              opacity:
                                item.awayScore < item.homeScore ? 1 : 0.2,
                            }"
                          >
                            胜
                          </div>
                        </div>
                        <div class="jc-img">
                          <img
                            v-if="item.guessOption == 1"
                            src="https://assets.rurushishi.com/activies/football/xuanzhong.png"
                          />
                        </div>
                      </div>
                      <div class="flat">
                        <div class="xqd">
                          <div class="bifen"></div>
                          <div
                            class="yz-jg"
                            :style="{
                              opacity:
                                item.awayScore == item.homeScore &&
                                item.homeScore !== -1
                                  ? 1
                                  : 0.2,
                            }"
                          >
                            平
                          </div>
                        </div>
                        <div class="jc-img">
                          <img
                            v-if="item.guessOption == 0"
                            src="https://assets.rurushishi.com/activies/football/xuanzhong.png"
                          />
                        </div>
                      </div>

                      <div class="fail">
                        <div class="xqd">
                          <div class="bifen" v-if="item.awayScore > -1">
                            {{ item.awayScore }}
                          </div>
                          <div class="bifen" v-else>--</div>
                          <div
                            class="yz-jg"
                            :style="{
                              opacity:
                                item.awayScore > item.homeScore ? 1 : 0.2,
                            }"
                          >
                            胜
                          </div>
                        </div>
                        <div class="jc-img">
                          <img
                            v-if="item.guessOption == -1"
                            src="https://assets.rurushishi.com/activies/football/xuanzhong.png"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-r">
                    <div class="dend" v-if="item.homeScore == -1">等待结果</div>
                    <div class="cg" v-if="item.finalPoint > 0">竞猜成功</div>
                    <div
                      class="shibai"
                      v-if="item.finalPoint == 0 && item.homeScore !== -1"
                    >
                      竞猜失败
                    </div>
                    <div class="hd-jf" v-if="item.finalPoint >= 0">
                      +{{ item.finalPoint }}澳朵金豆
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 暂无数据 -->
            <div class="no-data" v-if="myGuessData.length == 0">暂无数据 ~</div>
          </div>

          <div class="convertibility" v-else>
            <div
              class="jp-box"
              v-for="(item, index) in prize_list1"
              :key="index"
            >
              <div class="prize-img">
                <img :src="item.prizeIcon" alt="" />
              </div>
              <div class="prize-info">
                <div class="prize-name">{{ item.prizeName }}</div>
                <div class="prize-arg">
                  <span>{{ item.points }}澳朵金豆</span>
                  <!-- <span>剩余</span
                  ><span>{{ item.stockNum }}件</span> -->
                </div>
              </div>
              <!-- item.prizeType  -->
              <!-- <div
                class="prize-btn"
                v-if="(item.status == 0 ) && item.stockNum > 0 &&item.prizeType ==1"
                :style="{
                  opacity: (item.status == 0 ) && item.stockNum <= 0 &&item.prizeType ==1? 0.4 : 1,
                }"
                @click="onConvert(item)"
              >
                立即兑换
              </div> -->
              <!-- 实物立即兑换按钮 status是否兑换过  received是否有兑换码 -->
              <!-- <div
                class="prize-btn"
                v-if="item.status == 0 && item.received == 0 &&item.prizeType ==5"
                :style="{
                  opacity: item.status == 0 && item.received == 0 &&item.prizeType ==5? 1 : 0.4,
                }"
                @click="onConvert(item)"
              >
                立即兑换
              </div> -->
              <!--  -->
              <div class="tag" v-if="item.received">已兑换</div>
              <div class="is-bility" v-if="item.status == -1">暂未开放</div>
               <div
                class="prize-btn"
                v-if="(item.status == 0 ) && item.stockNum > 0"
                @click="onConvert(item)"
              >
                立即兑换
              </div>
              <div
                class="prize-btn"
                style="opacity: 0.4;"
                v-if="(item.status == 0 ) && item.stockNum <= 0"
              >
                立即兑换
              </div>
              <div
                class="is-bility"
                @click="onQcode(item)"
                v-if="item.status == 1 && item.received == 1&&item.prizeType ==5"
              >
                兑换码
              </div>
              <div
                class="is-bility"
                style="opacity: 0.4;"
                v-if="item.status == 1 && item.received == 1&&item.prizeType ==1"
              >
                兑换码
              </div>
              <div
                class="prize-btn"
                style="opacity: 0.4;"
                v-if="(item.status == 1 ) && item.received == 0"
              >
                立即兑换
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 奖品兑换 -->
    <div class="mymodal" v-show="showActInfo">
      <div class="info">
        <div class="info-title"></div>
        <div class="fare">
          <div class="title-kj">{{ titleGues1 }}</div>
          <div
            class="content-wz1"
            style="
              font-size: 14px;
              color: #666666;
              line-height: 18px;
              margin-bottom: 15px;
              text-align: center;
            "
          >
            {{ txt1 }}
          </div>
          <div class="btn" @click="onSelect()">确定</div>
          <div class="botBtn" @click="closeTc('info')">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="qrModel">
      <div class="qrCodeModel">
        <img class="qrImg" />
        <img
          class="close"
          
          src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png"
          alt
        />
      </div>
    </div> -->
    <showGuess
      ref="showGuess"
      :pointId="pointId"
      @fMethod="recentEvents"
    ></showGuess>
    <!-- 兑换码 -->
    <div class="mymodal" v-show="showQrCode">
      <div class="info">
        <div class="info-title"></div>
        <div class="fare">
          <div class="title-kj">兑换码</div>
          <div class="content-wz">
            <img :src="qrCode" alt="" />
          </div>
          <div style="color: #666; font-size: 12px; text-align: center">
            线下兑换奖品时，请出示兑换码哦
          </div>
          <div class="botBtn" @click="closeQc('value')">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>
  

<script>
import showGuess from "./showGuess.vue";
export default {
  components: {
    showGuess,
  },
  props: {},
  data() {
    return {
      prize_list: [],
      prize_list1: [],
      prizeInfo: "",
      showPrize: false,
      code: "",
      address1: "",
      time: "",
      timeStatus: true,
      winnerNum: 0,
      ShowList: true,
      myPointData: {},
      myGuessData: {},
      selsectType: "bility",
      showActInfo: false,
      titleGues: "获取竞猜机会",
      txt: "你的竞猜机会已用完，邀请好友参与可获得更多竞猜机会哦~",
      titleGues1: "奖品兑换",
      txt1: "兑换此奖品需20澳朵金豆,确定兑换吗",
      points: null,
      pointId: null,
      showQrCode: false,
      qrCode: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async receivePrize(item) {
      this.timeStatus = false;
      this.$modal.drawForm
        .alert({ prizeId: item.prizeId, isMyprize: true })
        .then(() => {
          this.timeStatus = true;
          this.getmygiftList();
        });
    },
    closeTc() {
      this.showActInfo = false;
    },
    closeQc() {
      //
      this.showQrCode = false;
    },
    async onSelect() {
      if(this.myPointData.currentPoint < this.points){
        this.showActInfo = false;
        return
      }
      const data = await this.$httpdf.get(
        this.apiHost + "fc/redeemPrize" + "?prizeId=" + this.pointId
      );
      if (data.code == 0) {
        this.$showModal("兑换成功");
        this.myPoints();
        this.getmygiftList();
        this.showActInfo = false;
      } else {
        this.$showModal(data.msg);
      }
    },
    recentEvents() {
      this.myPoints();
      this.getmygiftList();
    },
    async onQcode(item) {
      ///fc/qrCode
      this.showQrCode = true;
      const data = await this.$httpdf.get(
        this.apiHost + "fc/qrCode" + "?prizeId=" + item.id
      );
      if (data.code == 0) {
        // this.prize_list1 = data.data;
        this.qrCode = data.data.qrCode;
        console.log(data.data.qrCode, "+++___");
      }

      // console.log(item)
    },
    //fc/redeemPrize
    //我的礼品列表
    // async getmygiftList() {
    //   const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/myPrize')
    //   if (data.code == 0) {
    //     this.prize_list1 = data.data
    //     this.prize_list1.forEach((v, i) => {
    //       v.status === 2 && this.mathTime(i)
    //     })
    //   }
    onConvert(item) {
      this.pointId = item.id;
      this.points = item.points
      console.log("1112");
      if (this.$util.cookie.get("mobile")) {
        this.showActInfo = true;
        if (this.myPointData.currentPoint < item.points) {
          this.txt1 = `抱歉你的澳朵金豆不足，再接再厉~`;
          console.log("1113");
        } else {
          this.txt1 = `兑换此奖品需${item.points}澳朵金豆,确定兑换吗`;
          console.log("1114");
        }
      } else {
        console.log("111");
        this.$refs.showGuess.getMask();
      }
    },
    changeTag(type) {
      if (type == "guess") {
        this.ShowList = false;
      } else {
        this.ShowList = true;
      }
      this.selsectType = type;
    },
    async getmygiftList() {
      const data = await this.$httpdf.get(this.apiHost + "fc/prizes");
      if (data.code == 0) {
        this.prize_list1 = data.data;
      }
    },
    //我的积分
    async myPoints() {
      const data = await this.$httpdf.get(this.apiHost + "fc/myPoints");
      if (data.code == 0) {
        this.myPointData = data.data;
      }
    },
    //我的竞猜
    //fc/myGuess
    async myGuess() {
      const data = await this.$httpdf.get(this.apiHost + "fc/myGuess");
      if (data.code == 0) {
        this.myGuessData = data.data;
      }
    },
    mathTime(index) {
      if (!this.timeStatus) {
        return;
      }
      if (this.prize_list1[index].countdown > 0) {
        this.$set(
          this.prize_list1[index],
          "countTime",
          --this.prize_list1[index].countdown + "s后过期"
        );
      } else {
        this.prize_list1[index].countTime = "";
        return;
      }
      //递归每秒调用mathTime方法，显示动态时间效果
      setTimeout(() => {
        this.mathTime(index);
      }, 1000);
    },
    showInfo(item) {
      console.log(item);
      this.code = item.prizeCode;
      // this.address1 = JSON.parse(item.expandParams)
      this.address1 = item.address;
      this.time = "2021年6月16日9:00-2021年6月30日18:00";
      this.showPrize = true;
    },
  },
  destroyed() {
    this.timeStatus = false;
  },
  async mounted() {
    this.timeStatus = true;
    this.getmygiftList();
    this.myPoints();
    this.myGuess();
  },
};
</script>
<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 80px;
    .myinfo {
      display: flex;
      justify-content: space-between;
      padding: 24px;
      .info-l {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 14px;
        }
        span {
          font-size: 17px;
          color: #fff;
        }
      }
      .info-r {
        display: flex;
        align-items: center;
        color: #fff;
        .agg-integral {
          width: 70px;
          text-align: center;
          .num {
            font-size: 22px;
            line-height: 30px;
          }
          .tit {
            font-size: 10px;
            line-height: 18px;
          }
        }
        .solid {
          background-color: #fff;
          height: 70%;
          width: 0.5px;
        }
        .sur-integral {
          width: 80px;
          text-align: center;
          .num {
            font-size: 22px;
            line-height: 30px;
          }
          .tit {
            font-size: 10px;
            line-height: 18px;
          }
        }
      }
    }
    .kv {
      width: 343px;
      margin: 40px auto 0;
      img {
        max-width: 100%;
        height: auto;
      }
    }

    .model {
      width: 351px;
      margin: 16px auto 0;

      // display: flex;
      // flex-direction: column;
      // align-items: center;
      border-radius: 12px;
      box-sizing: border-box;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border: 5px solid;
      .modelBg {
        background-color: #fff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      .head-tab {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        background-color: rgba(68, 111, 104, 0.7);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        overflow: hidden;
        div {
          width: 168px;
          text-align: center;
          color: #58a72a;
          background-color: #fff;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          overflow: hidden;
        }
        .act-tab {
          width: 168px;
          text-align: center;
          color: #fff;
          background-color: #58a72a;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
      }
      .no-data {
        width: 100%;
        height: 160px;
        font-size: 12px;
        color: #666666;
        text-align: center;
        line-height: 160px;
        background-color: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .time-data {
        width: 100%;
        background-color: #f3f3f3;
        font-size: 14px;
        line-height: 30px;

        padding-left: 10px;
      }
      .schedule {
        padding: 0 10px;
        background-color: #ebf2ea;
        .game-item {
          display: flex;
          width: 100%;
          height: 95px;
          padding: 10px 0;
          .item-l {
            display: flex;
            align-items: center;
            width: 220px;
            height: 100%;
            .nation {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 170px;
              height: 100%;
              .nation-l {
                font-size: 14px;
                img {
                  width: 30px;
                  height: 30px;
                  margin-right: 10px;
                  border-radius: 15px;
                }
              }
            }
            .score {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              flex: 1;
              height: 100%;
              padding: 5px 0;
              font-size: 14px;
              .bifen {
                width: 18px;
                text-align: center;
              }
            }
            .victory {
              width: 70px;
              display: flex;
              align-items: center;
              justify-content: right;
              .xqd {
                display: flex;
                align-items: center;
                justify-content: right;
              }
              .yz-jg {
                font-size: 12px;
                background-color: #428fec;
                padding: 2px;
                border-radius: 4px;
                color: #fff;
                margin: 0 8px;
              }
              .jc-img {
                width: 14px;
                height: 12px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .flat {
              width: 70px;
              display: flex;
              align-items: center;
              justify-content: right;
              .bifen {
                width: 18px;
                text-align: center;
              }
              .xqd {
                display: flex;
                align-items: center;
                justify-content: right;
              }
              .yz-jg {
                background-color: #59a82a;
                font-size: 12px;
                padding: 2px;
                border-radius: 4px;
                color: #fff;
                margin: 0 8px;
              }
              .jc-img {
                width: 14px;
                height: 12px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .fail {
              width: 70px;
              display: flex;
              align-items: center;
              justify-content: right;
              font-size: 12px;
              .xqd {
                display: flex;
                align-items: center;
                justify-content: right;
              }
              .yz-jg {
                background-color: #ef4b57;
                padding: 2px;
                border-radius: 4px;
                color: #fff;
                margin: 0 8px;
              }
              .jc-img {
                width: 14px;
                height: 12px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
          .item-r {
            flex: 1;
            text-align: center;
            margin-left: 20px;
            border-left: 1px solid #cde4c2;
            padding: 10px 0;
            div {
              width: 60px;
              padding: 3px;
              line-height: 16px;
              border-radius: 5px;
              margin: 0 auto 10px;
              color: #fff;
              font-size: 12px;
              line-height: 18px;
            }
            .dend {
              background-color: #58a72a; //等待结果
            }
            .cg {
              background-color: #ff6c37; //竞猜成功
            }
            .shibai {
              background-color: #d8e2de; //等待结果
              color: #7787a2;
            }
            .hd-jf {
              color: #000;
            }
          }
        }
        .game-item:not(:last-child) {
          border-bottom: 1px solid #cde4c2;
        }
      }
      .guess {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        height: 500px;
        overflow: hidden;
        overflow-y: auto;
      }
      .convertibility {
        background-color: #fff;
        padding: 0 12px;
        .jp-box {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 0;
          .prize-img {
            width: 64px;
            height: 64px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .prize-info {
            width: 150px;
            .prize-name {
              font-size: 14px;
              line-height: 24px;
            }
            .prize-arg {
              padding-top: 5px;
              span:nth-child(1) {
                font-size: 11px;
                color: #fff;
                background-color: #ff7f38;
                padding: 3px 5px;
                border-radius: 3px;
                margin-right: 5px;
              }
              span:nth-child(2) {
                font-size: 12px;
                color: #ff6536;
                margin: 5px 0;
                margin-right: 5px;
              }
              span:nth-child(3) {
                font-size: 12px;
                color: #ff6536;
              }
            }
          }
          .prize-btn {
            width: 72px;
            height: 28px;
            color: #fff;
            border-radius: 14px;
            text-align: center;
            background-color: #58a72a;
            font-size: 12px;
            line-height: 28px;
          }
          .is-bility {
            width: 72px;
            height: 28px;
            color: #58a72a;
            border-radius: 14px;
            text-align: center;
            background-color: #eef6ea;
            border: 1px solid #58a72a;
            font-size: 12px;
            line-height: 28px;
          }
          .tag {
            position: absolute;
            top: 12px;
            left: 0;
            width: 34px;
            height: 16px;
            font-size: 10px;
            line-height: 16px;
            border-top-left-radius: 3px;
            text-align: center;
            color: #fff;
            background-color: #58a72a;
          }
        }
        .jp-box:not(:last-child) {
          border-bottom: 1px solid #cde4c2;
        }
      }
    }
  }

  .qrModel {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .qrCodeModel {
      position: relative;
      width: 240px;

      .qrImg {
        width: 240px;
      }

      .close {
        position: absolute;
        top: -38px;
        right: -15px;
        width: 30px;
        height: 30px;
        z-index: 1002;
      }
    }
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 100;
}

.info {
  width: 265px;
  background: #fff;
  border-radius: 10px;
  padding: 0 20px 20px;
  box-sizing: border-box;
  position: relative;
  .info-title {
    width: 265px;
    height: 106px;
    position: absolute;
    left: 50%;
    top: -100px;
    background: url($imgHost + "tanc.png") center / 100% no-repeat;
    transform: translateX(-50%);
  }
  .fare {
    font-size: 15px;
    font-family: PingFangSC;
    font-weight: 400;
    .schedule {
      width: 100%;
      padding: 0px 12px;
      border-radius: 8px;
      //   background-color: #ebf3e8;
      .game-item {
        display: flex;
        width: 100%;
        height: 80px;
        padding: 10px 0;

        .item-l {
          display: flex;
          align-items: center;
          width: 150px;
          height: 100%;

          .nation {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 90px;
            height: 100%;

            .nation-l {
              font-size: 12px;

              img {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                border-radius: 12px;
              }
            }
          }

          .score {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 60px;
            height: 100%;
            padding: 5px 0;
            font-size: 12px;
          }

          .victory {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              font-size: 10px;
              background-color: #428fec;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .flat {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              background-color: #59a82a;
              font-size: 10px;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .fail {
            display: flex;
            align-items: center;
            justify-content: right;
            font-size: 10px;

            span:last-child {
              background-color: #ef4b57;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }
        }

        .item-r {
          flex: 1;
          text-align: center;
          margin-left: 20px;
          border-left: 1px solid #cde4c2;

          .time {
            font-size: 12px;
            padding-top: 3px;
            line-height: 22px;
          }

          div {
            font-size: 10px;
            line-height: 16px;
          }
        }
      }

      .game-item:not(:last-child) {
        border-bottom: 1px solid #cde4c2;
      }
    }
    .title-kj {
      padding: 15px 0;
      text-align: center;
      font-size: 18px;
      color: #000;
    }
    .content-wz {
      width: 140px;
      height: 140px;
      margin: 0 auto;
    }
    .input_txt {
      margin-bottom: 10px;
    }
    .input_txt,
    .input_code {
      input {
        background-color: #f6f6f9;
        width: 100%;
        height: 28px;
      }
    }
    .input_code {
      display: flex;
      margin-bottom: 10px;
      .right {
        width: 90px;
        border: 1px solid #36841b;
        margin-left: 10px;
        color: #36841b;
        text-align: center;
        line-height: 28px;
        border-radius: 5px;
        // line-height: 60px;
      }
      .left {
        flex: 1;
      }
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    background-color: #fdb43a;
  }
  .botBtn {
    position: absolute;
    left: 50%;
    top: 130%;
    transform: translateX(-50%);
    // width: 140px;
    // height: 39px;
    // line-height: 39px;
    // background: #6488f7;
    // border-radius: 20px;
    // font-size: 18px;
    // font-family: PingFangSC;
    // font-weight: 500;
    // color: #ffffff;
    // text-align: center;
    width: 20px;
    height: 20px;
  }
}
</style>